import { cx } from '@linaria/core';
import { useRef, useEffect, useMemo } from 'react';
import { avoidBreakInside } from '@provider/print';
import { printAST } from '@utils/ast';
import { typesetKatex, usePlatformFirefox } from '@utils/common';
import { useComponentEntry } from '@utils/component-framework';
import { iGuideHtmlToPrintAST } from './ast.content-to-ast.js';
import { printPrinters } from './ast.printers.js';
import { richtextStyles } from './molecule.context.style.js';
import { input, title, answer, line } from './molecule.inputs.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useHTMLContent } from '../../ast/util.print-html.js';

function TaskInputs(props) {
  const ref = useRef(null);
  useEffect(() => {
    typesetKatex(ref);
  }, []);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    children: props.task.inputs.map(input => /*#__PURE__*/jsx(TaskInput, {
      taskId: props.task.id,
      entryKey: props.entryKey,
      input: input
    }, input.id))
  });
}
const AMOUNT_OF_LINES_FOR_INPUT = 4;
function TaskInput(props) {
  const isFirefox = usePlatformFirefox();
  const userEntry = useComponentEntry(props.entryKey, {
    select: entry => entry?.data.answers[props.taskId]?.[props.input.id] ?? ""
  });
  const formattedUserEntry = useHTMLContent(userEntry.data ?? "");
  const content = useMemo(() => {
    const ast = iGuideHtmlToPrintAST(props.input.text);
    return printAST(ast, printPrinters);
  }, [props.input.text]);
  return /*#__PURE__*/jsxs("div", {
    className: input,
    "data-is-firefox": isFirefox,
    ...(!userEntry.data?.length ? avoidBreakInside() : undefined),
    children: [props.input.text?.trim() && /*#__PURE__*/jsx("div", {
      className: cx(title, richtextStyles),
      children: content
    }), userEntry.data?.length ? /*#__PURE__*/jsx("div", {
      className: cx(answer, richtextStyles),
      children: formattedUserEntry
    }) : new Array(AMOUNT_OF_LINES_FOR_INPUT).fill(undefined).map((_, index) => /*#__PURE__*/jsx("div", {
      className: line
    }, index))]
  });
}

export { TaskInputs };
//# sourceMappingURL=molecule.inputs.js.map
